import crudlModuleGenerator from '@/_CRUDL/modules/generator';

export default crudlModuleGenerator('ocr', {
  customKeys: {
    create: null,
    read: null,
  },
  customEndpoints: {
    create: '/attachments/ocr',
    read: '/attachments/ocr/:id',
  },
});
